import Dexie from 'dexie'

const db = new Dexie('spmbetgame-large-state')
db.version(1).stores({
  largeState: 'betgameId'
})

/**
 * Persist allbets, liveRankings, liveRankingsByMatchday, chat_items to IndexedDB (Dexie).
 * Keyed by betgameId so data is per betgame and can grow large without hitting localStorage limits.
 *
 * @param {string|number|null} betgameId - current betgame id (no-op if falsy)
 * @param {{ allbets: Array, liveRankings: Array, liveRankingsByMatchday: Array, chat_items: Array }} payload
 */
export function saveLargeState (betgameId, payload) {
  if (!betgameId) return Promise.resolve()
  const key = String(betgameId)
  return db.largeState.put({
    betgameId: key,
    allbets: payload.allbets || [],
    liveRankings: payload.liveRankings || [],
    liveRankingsByMatchday: payload.liveRankingsByMatchday || [],
    chat_items: payload.chat_items || []
  })
}

/**
 * Load allbets, liveRankings, liveRankingsByMatchday, chat_items from IndexedDB for a betgame.
 *
 * @param {string|number|null} betgameId
 * @returns {Promise<{ allbets: Array, liveRankings: Array, liveRankingsByMatchday: Array, chat_items: Array }|undefined>}
 */
export function getLargeState (betgameId) {
  if (!betgameId) return Promise.resolve(undefined)
  return db.largeState.get(String(betgameId))
}
